import React, { useState, useEffect } from "react";
import styles from "./hero.module.css";
import { useNavigate } from "react-router-dom";

const Hero = ({ heroBanners }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev === heroBanners?.length - 1 ? 0 : prev + 1));
        }, 5000);

        return () => clearInterval(interval);
    }, [heroBanners?.length]);

    const handleShopNowClick = (buttonLink) => {
        // Extract just the path part from the full URL to avoid page reload
        const url = new URL(buttonLink);
        const relativePath = url.pathname; 
        
        // Navigate using relative path to preserve React context
        navigate(relativePath);
    };

    return (
        <div className={styles.sliderContainer}>
            {heroBanners?.map((slide, index) => {
                const titleParts = slide.title.split(" ");
                const middleIndex = Math.ceil(titleParts.length / 2);
                const firstLine = titleParts.slice(0, middleIndex).join(" ");
                const secondLine = titleParts.slice(middleIndex).join(" ");
                
                return (
                    <div
                        key={`${slide._id}-${index}`}
                        className={`${styles.slide} ${index === currentSlide ? styles.active : styles.hidden}`}
                    >
                        <img
                            src={slide.image}
                            alt={slide.title}
                            className={styles.slideImage}
                        />
                        <div className={styles.textOverlay}>
                            <h3 className={styles.heading}>{firstLine}</h3>
                            <h1 className={styles.subheading}>{secondLine}</h1>
                            <p className={styles.text}>{slide.description}</p>
                            <button 
                                className={styles.shopNowButton} 
                                onClick={() => handleShopNowClick(slide?.buttonLink)}
                            >
                                {slide.buttonText}
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Hero;
